import React, { Component } from "react";
import { SearchComponent } from "../../component/SearchComponent";
import { SearchComponentWithApi } from "../../component/SearchComponentWithApi";
import {
  FILTER_MAPPER,
  getLocalstorage,
  isValidArray,
  setLocalstorage
} from "../../helper";
import { Form } from "react-bootstrap";
import { get, isFunction, isNull } from "lodash";
import PropTypes from "prop-types";
import { Search } from "../reusableComponent/search";
import { filterNames } from "./filter.selector";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";

/**
 *  filterData => filtered data => it should be in array format
 *
 */

const style = {
  filterScroll: {
    padding: "15px 0px 35px",
    fontSize: "13px"
  }
};

class ResponsiveFilter extends Component {
  isDataLoaded = false;
  state = {
    search: {},
    selectedFilters: {},
    sortedListingArr: [],
    tabIndex: 0
  };

  componentDidMount() {
    const { filterData } = this.props;
    this.setState({
      filtersSortedData: filterData
    });
  }

  getFilteredData = (sortedListingArr, name) => {
    this.setState(prevState => {
      return {
        sortedListingArr: {
          ...prevState.sortedListingArr,
          [name]: sortedListingArr
        },
        isSearching: get(sortedListingArr, "isSearching")
      };
    });
  };

  handleCheckbox = (filter, filterName) => {
    const { onChange } = this.props;
    filter.checked = !filter.checked;
    isFunction(onChange) && onChange(filter, filterName, true, false);
  };

  getFilterBySearch = (search, filterName) => {
    const { onChange } = this.props;
    isFunction(onChange) &&
      onChange(search.searchedText, filterName, true, false);
  };

  getSearchedFilters = (filterList = [], searchText = "") => {
    return filterList.filter(item => {
      if (searchText === "") return true;
      else {
        const regex = new RegExp(searchText, "ig");
        return regex.test(item.displayName);
      }
    });
  };

  searchDocument = (e, filterName) => {
    this.setState({
      [filterNames[filterName]]: e.target.value.trim()
    });
  };

  getStateFilterVal = _filterName => {
    const {
      projectSponsoringMinistry,
      projectSector,
      recipientMinistryState,
      recipientState,
      issueSponsoringMinistry,
      recipientMinistry,
      recipientStateDepartment,
      guests,
      sponsoringDepartment,
      projectTags,
      projectStatus,
      projectLocation,
      centerState,
      districtProjectLocation
    } = this.state;
    switch (_filterName) {
      case "projectSponsoringMinistry":
        return projectSponsoringMinistry;
      case "projectSector":
        return projectSector;
      case "recipientMinistryState":
        return recipientMinistryState;
      case "recipientState":
        return recipientState;
      case "issueSponsoringMinistry":
        return issueSponsoringMinistry;
      case "recipientMinistry":
        return recipientMinistry;
      case "recipientStateDepartment":
        return recipientStateDepartment;
      case "guests":
        return guests;
      case "sponsoringDepartment":
        return sponsoringDepartment;
      case "projectTags":
        return projectTags;
      case "projectStatus":
        return projectStatus;
      case "projectLocation":
        return projectLocation;
      case "centerState":
        return centerState;
      case "districtProjectLocation":
        return districtProjectLocation;
      default:
        return "";
    }
  };

  render() {
    const { filterData, clearAll, filtersValue } = this.props;
    const { tabIndex } = this.state;
    const filtersKeysArr = Object.keys(filterData || {});
    // const minLengthForSearch = 5;
    if (!filtersKeysArr.length) {
      return null;
    }

    const tabIndexSelected = getLocalstorage("tabIndexSelected");
    //console.log(tabIndexSelected, tabIndex);

    return (
      isValidArray(filtersKeysArr) && (
        <Tabs
          className="common-filter-tabs-wrapper"
          selectedIndex={tabIndexSelected || 0}
          onSelect={index => {
            setLocalstorage("tabIndexSelected", index);
            this.setState({ tabIndex: index });
          }}
        >
          <TabList className="common-filter-tablist">
            {isValidArray(filtersKeysArr)
              ? filtersKeysArr.map(filterName => {
                  const currentFilter = filterData[filterName];
                  if (!isValidArray(get(currentFilter, "values"))) {
                    return null;
                  }
                  return (
                    <Tab
                      className="common-filter-tab-label"
                      selectedClassName="common-filter-tab-selected-label"
                    >
                      {" "}
                      {get(currentFilter, "displayName", "NA")}
                    </Tab>
                  );
                })
              : null}
          </TabList>

          {isValidArray(filtersKeysArr)
            ? filtersKeysArr.map(filterName => {
                const currentFilter = filterData[filterName];
                const filterCurrentValue = filtersValue[filterName];
                const _filterName =
                  filterNames[get(currentFilter, "displayName")];
                let searchedFilterList = this.getSearchedFilters(
                  get(currentFilter, "values"),
                  this.getStateFilterVal(_filterName)
                );
                if (!isValidArray(get(currentFilter, "values"))) {
                  return null;
                }
                return (
                  <TabPanel className="common-filter-tabpanel">
                    <Form.Group className="search-filters" key={filterName}>
                      {get(currentFilter, "searchable") ? (
                        <SearchComponentWithApi
                          keyName="search"
                          value={filterCurrentValue}
                          className={"in-filter-search-box"}
                          onChange={value => {
                            this.getFilterBySearch(value, filterName);
                          }}
                        />
                      ) : null}
                      {isValidArray(get(currentFilter, "values")) &&
                      get(currentFilter, "values").length > 10 ? (
                        <Search
                          placeholder="Search"
                          keyName="searchText"
                          onChange={e =>
                            this.searchDocument(e, currentFilter.displayName)
                          }
                        />
                      ) : null}
                      <div style={style.filterScroll}>
                        {isValidArray(searchedFilterList)
                          ? searchedFilterList.map((filter, index) => {
                              clearAll && (filter.checked = false);
                              if (isNull(get(filter, "displayName"))) {
                                return null;
                              }
                              return (
                                <Form.Check
                                  className={`form-checkbox ${
                                    get(filter, "checked") ? "checked" : ""
                                  }${
                                    get(filter, "count") ||
                                    filterName === "projectGroupBy"
                                      ? ""
                                      : "checkbox-disabled"
                                  }`}
                                  key={`stage-${get(filter, "key")}`}
                                >
                                  <Form.Check.Input
                                    type="checkbox"
                                    name="ministry-issues"
                                  />
                                  <Form.Check.Label
                                    name={`stage-${get(filter, "key")}`}
                                    onClick={e => {
                                      e.stopPropagation();
                                      this.handleCheckbox(filter, filterName);
                                    }}
                                  >
                                    <span>
                                      {get(filter, "displayName")}
                                      {get(filter, "count") &&
                                      get(filter, "count") >= 0
                                        ? `(${get(filter, "count")})`
                                        : ""}
                                    </span>
                                  </Form.Check.Label>
                                </Form.Check>
                              );
                            })
                          : null}
                      </div>
                    </Form.Group>
                  </TabPanel>
                );
              })
            : null}
        </Tabs>
      )
    );
  }
}

ResponsiveFilter.propTypes = {
  filterData: PropTypes.array,
  callApiOnSuccess: PropTypes.func
};

ResponsiveFilter.defaultProps = {
  filterData: [],
  callApiOnSuccess: () => {}
};

export default ResponsiveFilter;
